import React from "react";
import SchedulerImg from "../assets/images/new-dashboards/scheduler.png";
import DragIcon from "../assets/icons/drag.png";
import EasyIcon from "../assets/icons/easy.png";
import { ContactForm } from "../components/ContactForm";

export function LucidVisualScheduler() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="newModuleHeader">
        <div className="newBackground"></div>
        <h3 className="mainSubhead white">Alpaca Visual Scheduler</h3>
        <p className="body-text white">
          Track and visualize shop floor progress in real-time with this
          centralized scheduling application.
        </p>
        <img
          src={SchedulerImg}
          alt="Alpaca Visual Scheduler Dashboard"
          className="module-img"
        />
      </section>

      <section className="module-info">
        <div>
          <p className="body-text left">
            There is a disconnect with out-of-the-box NAV systems order planning
            and manufacturing. Alpaca Visual Scheduler solves this disconnect
            with
            <strong>
              {" "}
              easy-to-use, intuitive drag and drop feature that organizes orders
              on a centralized dashboard.
            </strong>{" "}
            It provides users with real-time visibility on the status of their
            orders and the loading of manufacturing assets. The system also
            sends notifications on potential delays that allows timely decision
            making to remedy any situations.
          </p>

          <p className="body-text left">
            Users can also apply the data to schedule orders in the way that
            makes most sense. Perhaps it's by organizing the same components
            together to increase efficiency, or maybe it makes more sense to
            complete full orders at once to expedite the delivery, or even to
            customize according to unique business needs.
          </p>
        </div>

        <div>
          <div className="container-img-text">
            <img src={DragIcon} alt="Drag n' Drop Interface Icon" />
            <div>
              <h3 className="smallSubhead">Drag n' Drop Interface</h3>
              <p className="small-text">
                Eliminate spreadsheets or manually entering in numbers from one
                document to another (finally!). Simply click on a job, enter the
                data and release the cursor where you want the task to live.
              </p>
            </div>
          </div>

          <div className="container-img-text">
            <img src={EasyIcon} alt="Easy to Use Interface Icon" />
            <div>
              <h3 className="smallSubhead">Painless to Use</h3>
              <p className="small-text">
                The Alpaca Visual Scheduler allows users to visualize your
                production process and make it easy and transparent for everyone
                to see the status of production.
              </p>
            </div>
          </div>
        </div>
      </section>
      <ContactForm />
    </>
  );
}
